import { render, staticRenderFns } from "./TheServiciosComplementarios.vue?vue&type=template&id=3849d5f8&"
import script from "./TheServiciosComplementarios.vue?vue&type=script&lang=js&"
export * from "./TheServiciosComplementarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports